import React from "react";

// Subtle proprietary brand tag shown beside primary asset values so users anchor on
// the "DME value" (Dynasty Metrics Engine) as the proprietary market standard.
export default function DmeTag({ className = "" }) {
  return (
    <span
      title="Dynasty Metrics Engine — our proprietary asset valuation"
      data-testid="dme-tag"
      className={`inline-flex items-center font-mono text-[9px] font-semibold leading-none tracking-[0.15em] text-[var(--accent)] border border-[var(--accent)]/30 bg-[var(--accent)]/10 rounded-sm px-1 py-0.5 align-middle ${className}`}
    >
      DME
    </span>
  );
}
